import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { KIOSK__SHELL_ACTIVE_SUBTITLE } from 'translations/constants';
import { getGreetingKey } from '../kiosk-selection-helpers';
import { KioskGreetingSubtitle, KioskGreetingTitle } from '../styles';

/** Centered time-of-day greeting + fixed subtitle. */
const KioskGreeting = () => {
  const [t] = useTranslation();
  return (
    <Box sx={{ paddingTop: '4px' }}>
      <KioskGreetingTitle variant="h2">{t(getGreetingKey())}</KioskGreetingTitle>
      <KioskGreetingSubtitle>{t(KIOSK__SHELL_ACTIVE_SUBTITLE)}</KioskGreetingSubtitle>
    </Box>
  );
};

export default KioskGreeting;
